import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementVersions } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_VERSIONS } from "consts";

export const useGetPracticeManagementVersions = () =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_VERSIONS],
    queryFn: getPracticeManagementVersions,
  });
